<template>
  <div class="reset-password">
    <router-link v-if="!isSent"
                 to="/user/sign-in"
                 class="reset-password__back">
      <span class="reset-password__back_arrow"></span> BACK
    </router-link>
    <p class="reset-password__title">{{ title }}</p>
    <p class="reset-password__desc" :class="{'reset-password__desc_sent': isSent}" v-html="desc"></p>
    <template v-if="!isSent">
      <input type="text"
             v-model="email"
             :disabled="isDataUpdating"
             class="reset-password__email"
             :class="{ 'reset-password__email_error': errorFields.email }"
             placeholder="Email">
      <base-material-design-icon class="reset-password__email_icon" icon="email"/>
      <span v-if="errorFields.email" class="reset-password__email_error-message">{{ errorFields.email }}</span>
    </template>
    <button :disabled="isDataUpdating"
            class="reset-password__submit"
            @click.prevent="onSubmit">
      {{ submit }}
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ResetPassword',
  data () {
    return {
      isSent: false,
      isDataUpdating: false,
      errorFields: {},
      email: ''
    }
  },
  computed: {
    title () {
      return this.isSent ? 'Instruction was sent' : 'Forgot Password'
    },
    submit () {
      return this.isSent ? 'SIGN IN' : 'SEND'
    },
    desc () {
      return this.isSent
        ? `A reset password email has been sent to <br><span style="font-weight: bold">‘${this.email}’</span>. Open that email and follow the instructions to reset your password.`
        : 'Enter your email, and we will send you the instruction to reset your password.'
    }
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    async onSubmit () {
      if (!this.isSent) {
        this.isDataUpdating = true
        const response = await this.resetPassword({ email: this.email })
        this.isDataUpdating = false
        this.errorFields = response.error_fields || {}
        this.isSent = response.is_successful
      } else {
        this.$router.push({ path: '/user/sign-in' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .reset-password {
    width: 394px;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 6px 16px 0 rgba(96, 97, 112, 0.2), 0 1px 4px 0 rgba(40, 41, 61, 0.06);
    padding: 64px 48px 48px;

    p {
      width: 394px;
    }

    &__submit {
      display: block;
      margin: 48px auto 0;
      outline: none;
      border: none;
      padding: 16px 59px;
      line-height: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      background-color: $rfx-bright-turquoise;
      border-radius: 8px;

      &:disabled {
        pointer-events: none;
        opacity: .4;
      }
    }

    &__email {
      display: inline-block;
      width: -webkit-fill-available;
      line-height: 24px;
      border-radius: 8px;
      border: solid 1px #7c8e9b;
      padding: 16px 16px 16px 56px;
      color: $rfx-medium-march !important;
      margin: 1px;

      &:disabled {
        background-color: #7c8e9b40;
      }

      &_error-message {
        display: inline-block;
        color: $rfx-light-red;
        margin-top: 8px;
        font-size: 14px;
        line-height: 16px;
      }

      &_error {
        border-color: $rfx-light-red !important;
      }

      &::placeholder {
        color: $rfx-medium-march;
      }

      &:focus {
        border: 2px solid $rfx-bright-turquoise;
        outline: none;
        margin: 0;
      }

      &_icon {
        display: block;
        font-size: 24px;
        color: $rfx-medium-march;
        width: 0;
        height: 0;
        position: relative;
        left: 18px;
        top: -18px;
      }
    }

    &__desc {
      margin: 0 0 48px;
      padding: 0;
      font-size: 14px;
      line-height: 20px;
      color: $rfx-medium-march;
    }

    &__title {
      margin: 0 0 16px;
      padding: 0;
      color: $rfx-dark-march;
      font-size: 32px;
      font-weight: bold;
    }

    &__back {
      display: inline-block;
      color: $rfx-dark-march;
      font-size: 14px;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 24px;
      text-decoration: none;

      &_arrow {
       margin-right: 20px;
       padding: 4px;
       border: solid $rfx-dark-march;
       border-width: 0 2px 2px 0;
       display: inline-block;
       transform: rotate(135deg);
      }
    }

  }

  @media only screen and (max-width: 490px) {
    .reset-password {
      width: -webkit-fill-available;
      min-height: -webkit-fill-available;
      padding: 24px 24px 32px;
      border-radius: 0;
      display: flex;
      flex-direction: column;

      p {
        width: -webkit-fill-available;
      }

      &__back {
        padding-left: 12px;
        margin-bottom: 16px;
        font-weight: bold;
      }

      &__title {
        text-transform: capitalize;
        margin-top: auto;
        font-size: 24px;
        font-weight: bold;
      }

      &__desc {
        margin-bottom: 32px;

        &_sent {
          margin-bottom: 0;
        }
      }

      &__email_icon {
        align-self: auto;
      }

      &__submit {
        margin-top: 32px;
        margin-bottom: auto;
      }
    }
  }
</style>
